import { I18n } from '@affine/i18n';
import { WithDisposable } from '@blocksuite/affine/global/lit';
import { unsafeCSSVarV2 } from '@blocksuite/affine/shared/theme';
import { ShadowlessElement } from '@blocksuite/affine/std';
import { ToolIcon } from '@blocksuite/icons/lit';
import { css, html, type TemplateResult } from 'lit';
import { property } from 'lit/decorators.js';

import { aiChatStatusTypography } from '../../styles/ai-chat-typography';

export class ToolFailedCard extends WithDisposable(ShadowlessElement) {
  static override styles = css`
    .ai-tool-failed-wrapper {
      padding: 6px 10px;
      margin: 4px 0;
      border-radius: 8px;
      border: 0.5px solid ${unsafeCSSVarV2('layer/insideBorder/border')};
      background-color: ${unsafeCSSVarV2('layer/background/primary')};

      .ai-tool-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 6px;
      }

      .ai-icon {
        width: 18px;
        height: 18px;
        flex-shrink: 0;

        svg {
          width: 18px;
          height: 18px;
          display: block;
          flex-shrink: 0;
          color: ${unsafeCSSVarV2('button/error')};
        }
      }

      .ai-error-name {
        ${aiChatStatusTypography}
        font-weight: 500;
        margin-left: 0px;
        margin-right: auto;
        color: ${unsafeCSSVarV2('button/error')};
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  `;

  @property({ attribute: false })
  accessor name: string = I18n.t('com.streamlain.ai.tool.failed.default');

  @property({ attribute: false })
  accessor icon: TemplateResult<1> = ToolIcon();

  protected override render() {
    return html`
      <div class="ai-tool-failed-wrapper">
        <div class="ai-tool-header">
          <div class="ai-icon">${this.icon}</div>
          <div class="ai-error-name">${this.name}</div>
        </div>
      </div>
    `;
  }
}
